module.exports = __webpack_public_path__ + "static/banner-ddad04fb9bcc49926197750c9a9cb007.png";